<form *transloco="let t" [formGroup]="loginForm" [class.was-validated]="loginForm.touched || submitted()" (ngSubmit)="login()">
  <div class="row">
    <div class="col">
      <app-email-field
        [formControl]="loginForm.controls.email"
        [maxLength]="255"
        [label]="t('auth.login.Email')">
      </app-email-field>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <app-password-field
        [formControl]="loginForm.controls.password"
        [maxLength]="255"
        [isBadCredentials]="isBadCredentials"
        [label]="t('auth.login.Password')">
      </app-password-field>
    </div>
  </div>
  <div class="row my-2">
    <div class="col">
      <div class="d-grid gap-2 d-md-flex justify-content-md-end">
        <button type="button" class="btn btn-link mx-1" (click)="openResetDialog()">{{ t('auth.login.ResetPassword') }}</button>
        @if (canRegister) {
          <a class="btn btn-tertiary mx-1" [routerLink]="registerRoute">
            {{ t('auth.login.Register') }}
          </a>
        }
        <button
          type="submit"
          class="btn btn-primary mx-1">
          {{ loginBtnLabel || t('auth.login.Login') }}
          <lucide-icon [img]="icons.login"></lucide-icon>
        </button>
      </div>
    </div>
  </div>
</form>

<dialog class="p-4" *transloco="let t" #resetPasswordDialog>
  <p class="fw-bold">
    {{ t('auth.login.ResetTitle') }}
  </p>
  <form [formGroup]="resetForm" [class.was-validated]="resetForm.touched" (ngSubmit)="resetPassword()">
    <app-email-field
      [formControl]="resetForm.controls.email"
      [maxLength]="255"
      [label]="t('auth.login.Email')">
    </app-email-field>
    <app-altcha formControlName="captcha"/>

    <div class="d-grid gap-2 d-md-block mt-3">
      <button type="button" class="btn btn-link max-2" (click)="closeResetDialog()">
        {{ t('auth.login.BtnCancelReset') }}
      </button>
      <button type="button" class="btn btn-primary mx-2" (click)="resetPassword()" [disabled]="!resetForm.valid">
        {{ t('auth.login.BtnReset') }}
      </button>
    </div>
  </form>
</dialog>
